import { DietPreference, MealOption } from "./MealSettings";

const update = (mealOptions: MealOption[], change: MealOption): MealOption[] =>
  mealOptions.map((option) =>
    change.mealOptionId === option.mealOptionId ? change : option
  );

const updateAll = (
  mealOptions: MealOption[],
  preferences: DietPreference[]
): MealOption[] =>
  mealOptions.map((option) => ({
    ...option,
    dietPreferences: preferences,
  }));

const updateDisabled = (mealOption: MealOption, disabled: boolean): MealOption => ({
  ...mealOption,
  disabled,
  toBeOrdered: disabled ? false : mealOption.toBeOrdered,
});

const updateToBeOrdered = (mealOption: MealOption, toBeOrdered: boolean): MealOption => ({
  ...mealOption,
  toBeOrdered,
  disabled: toBeOrdered ? false : mealOption.disabled,
});

const updateFoodFree = (mealOption: MealOption, foodFree: boolean): MealOption => ({
  ...mealOption,
  foodFree,
});

const updateDietPreferences = (
  mealOption: MealOption,
  dietPreferences: DietPreference[]
): MealOption => ({
  ...mealOption,
  dietPreferences,
});

export const MealOptionUtils = {
  update,
  updateAll,
  updateDisabled,
  updateToBeOrdered,
  updateFoodFree,
  updateDietPreferences,
} as const;
